import { render, staticRenderFns } from "./MyStatic.vue?vue&type=template&id=231e044a&scoped=true&"
import script from "./MyStatic.vue?vue&type=script&lang=js&"
export * from "./MyStatic.vue?vue&type=script&lang=js&"
import style0 from "./MyStatic.vue?vue&type=style&index=0&id=231e044a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231e044a",
  null
  
)

export default component.exports